/**
 * Singleton loader for the Adobe PDF Embed SDK.
 *
 * The SDK is loaded once per page; subsequent calls return the same Promise.
 * Resolves to true when AdobeDC is available, false if loading fails or we're
 * running on the server. Used by AdobePdfViewer.vue.
 */

let loadPromise = null;

const SDK_URL = 'https://acrobatservices.adobe.com/view-sdk/viewer.js';

export const loadAdobeSdk = () => {
    if (typeof window === 'undefined') return Promise.resolve(false);
    if (window.AdobeDC) return Promise.resolve(true);
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve) => {
        const onReady = () => {
            document.removeEventListener('adobe_dc_view_sdk.ready', onReady);
            resolve(true);
        };
        document.addEventListener('adobe_dc_view_sdk.ready', onReady);

        const script = document.createElement('script');
        script.src = SDK_URL;
        script.async = true;
        script.onerror = () => {
            console.error('Failed to load Adobe PDF Embed SDK from', SDK_URL);
            document.removeEventListener('adobe_dc_view_sdk.ready', onReady);
            loadPromise = null;
            resolve(false);
        };
        document.head.appendChild(script);
    });

    return loadPromise;
};
